module.exports = __webpack_public_path__ + "static/media/file.319a4b16.png";